<template>
  <div>
    <el-form class="quantity-editor">
      <el-form-item :label="$t('FinanceManage.Quantity')">
        <el-input v-model="form.quantity" size="mini" style="width: 100px" @change="quantityChangeHandler" />
      </el-form-item>
      <el-form-item :label="$t('FinanceManage.UnitPrice')">
        <el-input v-model="form.price" size="mini" style="width: 100px" @change="priceChangeHandler" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'

export default Vue.extend({
  name: 'QuantityEditor',
  mixins: [TableKeyboardNav],
  data() {
    return {
      form: {
        quantity: 0,
        price: 0
      },
      accountTitle: {}
    }
  },
  computed: {
    accountSet() {
      return this.params.accountSet
    }
  },
  created() {
    // console.log('oninputeditor')
    // this.value = this.params.value
  },
  mounted() {
    this.value = this.params.value ? this.params.value : ''
    this.form.quantity = 0
    this.form.price = 0
    if (this.params.accountingEntry && this.params.accountingEntry.accountTitle !== undefined) {
      this.form.quantity = this.params.accountingEntry.quantity ? this.params.accountingEntry.quantity : 0
      this.form.price = this.params.accountingEntry.price ? this.params.accountingEntry.price : 0
      if (this.form.price === 0 && !isNaN(this.form.quantity) && !isNaN(this.params.accountingEntry.amount)) {
        const quantityNum = Number(this.form.quantity)
        if (quantityNum) this.form.price = this.params.accountingEntry.amount / quantityNum
      }
    }
    if (this.params.accountTitle) {
      this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.params.accountTitle)
    }
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        this.$refs.input.select()
      }
    })
  },
  methods: {
    getValue() {
      this.params.accountingEntry.quantity = this.form.quantity
      this.params.accountingEntry.price = this.form.price
      // return [this.form.quantity, this.form.price]
      let msg = ''
      if (this.form.quantity) msg = this.$t('FinanceManage.Quantity') + this.form.quantity
      if (this.form.price) msg += (StrUtils.isEmpty(msg) ? '' : ' \n') + this.$t('FinanceManage.UnitPrice') + this.form.price
      return msg
    },
    quantityChangeHandler(newVal) {
      this.quantityTextFocusOutHandler()
    },
    priceChangeHandler(newVal) {
      this.quantityTextFocusOutHandler()
    },
    // 数量核算数据更改
    quantityTextFocusOutHandler() {
      if (!this.accountTitle && this.params.accountTitle) {
        this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.params.accountTitle)
      }
      if (!this.accountTitle || !this.accountTitle.accountingQuantity) return
      if (!isNaN(this.form.quantity) && !isNaN(this.form.price)) {
        const quantityNum = Number(this.form.quantity).toFixed(2)
        const priceNum = Number(this.form.price).toFixed(2)
        const amount = NumberUtils.roundHalfUp(quantityNum * priceNum, 2)
        // 有外币核算计算原币金额
        if (this.accountTitle.accountingCurrency && this.params.accountingEntry.sourceCurrency !== this.accountSet.localCurrency) {
          this.params.accountingEntry.sourceAmount = amount
          // 计算借方金额/贷方金额
          this.calculateAmount()
        } else {
          // 无外币核算
          if (this.params.accountingEntry.debitAmount) {
            this.params.accountingEntry.debitAmount = amount
          } else {
            this.params.accountingEntry.crebitAmount = amount
          }
        }
      } else {
        if (isNaN(this.form.quantity)) this.params.accountingEntry.quantity = 0
        if (isNaN(this.form.price)) this.params.accountingEntry.price = 0
        // 清空原币
        this.params.accountingEntry.sourceCurrency = ''
        // 清空借方金额/贷方金额
        this.params.accountingEntry.debitAmount = 0
        this.params.accountingEntry.crebitAmount = 0
      }
    },
    // 计算本位币
    calculateAmount() {
      if (!this.accountTitle && this.params.accountTitle) {
        this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.params.accountTitle)
      }
      if (!this.accountTitle || !this.accountTitle.accountingCurrency) return
      if (!isNaN(this.params.accountingEntry.sourceAmount) && !isNaN(this.params.accountingEntry.exchangeRate)) {
        const exchangeRateNum = Number(this.params.accountingEntry.exchangeRate).toFixed(6)
        const sourceCurrencyNum = Number(this.params.accountingEntry.sourceAmount).toFixed(2)
        if (this.params.accountingEntry.summary === '期末调汇' && sourceCurrencyNum === 0) {
          // CARGO-9063，期末调汇关于外币的科目金额不显示
        } else {
          const amount = NumberUtils.roundHalfUp(exchangeRateNum * sourceCurrencyNum, 2)
          if (this.params.accountingEntry.debitAmount) {
            this.params.accountingEntry.debitAmount = amount
          } else {
            this.params.accountingEntry.crebitAmount = amount
          }
        }
      } else {
        this.params.accountingEntry.debitAmount = 0
        this.params.accountingEntry.crebitAmount = 0
      }
    }
  }
})
</script>
<style lang="scss" scoped>
.quantity-editor{
  .el-form-item{
    margin-bottom: 2px !important;
  }
}
</style>
